import { Component } from '@angular/core';

@Component({
  selector: 'app-confirm-setup-two-factor-dialog',
  templateUrl: './confirm-setup-two-factor-dialog.component.html',
  standalone: false,
})
export class ConfirmSetupTwoFactorDialogComponent {}
